import { useState } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { Burger, Drawer, Anchor, Group, Box, Container, Image } from '@mantine/core';
import { Stack } from '@mantine/core';

import classes from './Header.module.css';

import logo from './../../imgs/logo.png';
import whatsappLogo from './../../imgs/whatsapp-logo.svg';
import phoneIcon from './../../imgs/phone.svg';

const userLinks = [
  { link: 'https://wa.me/8138924955', label: 'WhatsApp', icon: whatsappLogo },
  { link: 'tel:8138924955', label: 'NL: 81-3892-4955', icon: phoneIcon },
  { link: 'tel:9845559929', label: 'Yuc: 984-555-9929', icon: null },
];

const mainLinks = [
  { link: '#inicio', label: 'Inicio' },
  { link: '#ventajas', label: 'Ventajas' },
  { link: '#como-funciona', label: '¿Cómo funciona?' },
  { link: '#requisitos', label: 'Requisitos' },
  { link: '#preguntas-frecuentes', label: 'Preguntas frecuentes' },
  { link: '#contacto', label: 'Contacto' },
];

export function Header() {
  const [opened, { toggle, close }] = useDisclosure(false);
  const [active, setActive] = useState(0);

  const mainItems = mainLinks.map((item, index) => (
    <Anchor<'a'>
      href={item.link}
      key={item.label}
      className={classes.mainLink}
      data-active={index === active || undefined}
      onClick={(event) => {
        setActive(index);
        close(); // Cierra el drawer al hacer clic en un enlace
      }}
    >
      {item.label}
    </Anchor>
  ));

  const secondaryItems = userLinks.map((item) => (
    <Anchor href={item.link} key={item.label} className={classes.secondaryLink}>
      {item.icon && (
        <Image src={item.icon} alt={item.label} className={classes.secondaryLinkIcon} />
      )}
      {item.label}
    </Anchor>
  ));

  return (
    <header className={classes.header}>
      <Container className={classes.inner}>
        <img src={logo} alt="Logo" className={classes.logo} />
        <Box className={classes.links} visibleFrom="sm">
          <Group justify="flex-end">{secondaryItems}</Group>
          <Group gap={0} justify="flex-end" className={classes.mainLinks}>
            {mainItems}
          </Group>
        </Box>
        <Burger
          opened={opened}
          onClick={toggle}
          className={classes.burger}
          size="sm"
          hiddenFrom="sm"
        />

        {/* Drawer para móviles */}
        <Drawer
          opened={opened}
          onClose={close}
          size="lg"
          padding="lg"
          title="Menú"
          hiddenFrom="sm"
          zIndex={1000000}
          position="right"
          styles={{
            body: {
              height: '98%',
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          <Stack gap="sm">{mainItems}</Stack>

          <Stack gap="sm" className={classes.drawerSecondarySection}>
            {secondaryItems}
          </Stack>
        </Drawer>
      </Container>
    </header>
  );
}
